module.exports = new __parcel__URL__("29800_sq.20b6b20d.jpg").toString();